import { useEffect, useState, useRef } from 'react';

export type ContextMenuPosition = {
    mouseX: number;
    mouseY: number;
};

export function useBookingOrderListContextMenu() {
    let orderListCardRef = useRef(null);
    let [position, setPosition] = useState<ContextMenuPosition | null>(null);

    function handleContextMenu(event: MouseEvent) {

        if (orderListCardRef.current.contains(event.target)) {
            event.preventDefault();
            setPosition({
                mouseX: event.clientX + 2,
                mouseY: event.clientY - 6
            });
        } else {
            setPosition(null);
        }
    }

    function handleClose() {
        setPosition(null);
    }

    useEffect(() => {
        document.addEventListener('contextmenu', handleContextMenu);

        return () => {
            document.removeEventListener('contextmenu', handleContextMenu);
        };
    }, []);

    return {
        orderListCardRef,
        contextMenuPosition: position,
        onCloseContextMenu: handleClose
    };
}
